import * as Dialog from '@radix-ui/react-dialog'
import PropTypes from 'prop-types'
import { createUseStyles } from '../../helpers/createStyles'
import IconCloseMobile from '../../icons/gallery-close-mobile.svg'
import IconArrowLeftMobile from '../../icons/gallery-arrow-left-mobile.svg'

const GalleryNavigation = ({
  handlePressNext,
  handlePressPrev,
  nextDisabled,
  prevDisabled
}) => {
  const styles = useStyles()
  return (
    <div className={styles.root}>
      <button
        onClick={handlePressPrev}
        className={styles.navButton}
        disabled={prevDisabled}
        aria-label='Previous image'
      >
        <IconArrowLeftMobile />
      </button>
      <Dialog.Close className={styles.navButton}>
        <IconCloseMobile />
      </Dialog.Close>
      <button
        onClick={handlePressNext}
        className={styles.navButton}
        disabled={nextDisabled}
        aria-label='Next image'
      >
        <IconArrowLeftMobile className={styles.arrowRight} />
      </button>
    </div>
  )
}

const useStyles = createUseStyles({
  root: {
    display: 'flex',
    height: 120,
    justifyContent: 'space-around',
    alignItems: 'center',
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0
  },
  navButton: {
    width: 48,
    height: 48,
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'opacity 150ms',
    '&:disabled': {
      opacity: 0
    }
  },
  arrowRight: {
    transform: 'rotate(180deg)'
  }
})

GalleryNavigation.propTypes = {
  handlePressNext: PropTypes.func.isRequired,
  handlePressPrev: PropTypes.func.isRequired,
  nextDisabled: PropTypes.bool.isRequired,
  prevDisabled: PropTypes.bool.isRequired
}

export default GalleryNavigation
